<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    width="600px"
    @confirm="confirm"
  >
    <el-descriptions title="" :column="1" >
      <el-descriptions-item label="车编号">{{ form.bikeCode }}</el-descriptions-item>
      <el-descriptions-item label="车类型">{{ form.bikeType }}</el-descriptions-item>
      <el-descriptions-item label="借出时间">{{ form.rentDate }}</el-descriptions-item>
      <el-descriptions-item label="借出站点">{{ form.rentSiteId }}</el-descriptions-item>
      <el-descriptions-item label="锁止器号">{{ form.rentLockId }}</el-descriptions-item>
    </el-descriptions>
    <el-form :model="form" ref="form" :rules="backInfoRequired ? rules2 : rules " label-suffix="：">
      <el-form-item label="还车原因" prop="backReason">
        <el-select v-model="form.backReason" placeholder="请选择还车原因" @change="selectReason">
          <el-option
            v-for="item in reason"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
        <!-- <el-input v-model="form.backReason" placeholder="请输入调整原因" v-trim/> -->
      </el-form-item>
      <el-form-item label="还车备注" prop="backInfo">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          v-model="form.backInfo"
          placeholder="请输入调整备注"
          v-trim
        />
      </el-form-item>
      
    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
import { forceBack } from '@/api/business/memberRides'
import { baseParamList } from '@/api/business/baseParam'
// import { findList } from '@/api/business/roomTime'
export default {
  name: 'OperaSuggestWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        bikeCode: '',
        rentSiteId: '',
        rentLockId: '',
        bikeType: '',
        rentDate: '',
        backReason: '',
        backInfo: '',
      },
      reason: [],
      backInfoRequired: false,
      // 验证规则
      rules: {
        backReason: [
          { required: true, message: '请选择还车原因', tigger: 'change'},
        ]
      },
      rules2: {
        backReason: [
          { required: true, message: '请选择还车原因', tigger: 'change'},
        ],
        backInfo: [
          { required: true, message: '请输入还车备注', tigger: 'blur'},
        ],
      }
    }
  },
  created () {
    baseParamList({type: 1})
      .then(res => {
        this.reason = res
      })
  },
  methods: {
    /**
     * 打开窗口
     * @title 窗口标题
     * @target 编辑的对象
     */
     open (title, target) {
      this.title = title
      this.visible = true
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.form.backReason = ''
        this.form.backInfo = ''
        this.$refs.form.clearValidate()
      })
    },
    selectReason(v) {
      let item = this.reason.find(item => item.name == v)
      this.backInfoRequired = item.required == 1
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        this.isWorking = true
        forceBack(this.form)
          .then(res => {
            this.visible = false
            this.$tip.apiSuccess('还车成功')
            this.$emit('success')

          })
          .catch(err => {
            this.$tip.apiFailed(err)
          })
          .finally(() => {
            this.isWorking = false
          })
      })
    }
  },
}
/**
 * 
 */
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
@import "@/assets/style/variables.scss";

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #fff !important;
  cursor: pointer;
}

.time-style {
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  .time-item {
    margin-right: 8px;
    margin-bottom: 8px;
    border: #111 solid 1px;
    font-size: 14px;
    line-height: 14px;
    padding: 5px;
    border-radius: 5px;
    color: #111;
  }
  .time-item-sel {
    border-color: $primary-color;
    background-color: $primary-color;
    color: #fff;
  }
  .time-item-disable {
    border-color: #999;
    background-color: #999;
    color: #111;
  }
}

</style>
